import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ImportResult } from '../../../models';
import { ILoggerService, IAccountService } from '../../../services';

class ImportUserCsvModalController implements angular.IComponentController {
    errorMessage: string;
    fileList: FileList;
    importResult: ImportResult;
    isLoading: boolean;
    loadingMessage: string;
    preventClose: boolean = true;

    readonly modalId: string;
    readonly refresh: () => void;

    static $inject = [
        '$translate',
        '$timeout',
        'accountService',
        'loggerService'
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _$timeout: angular.ITimeoutService,
        private _accountService: IAccountService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._$timeout(() => {
            angular.element(`#${this.modalId}`)
                .on('hidden.bs.modal', () => {
                    this.reset();
                });
        });
    }

    importUserCsv() {
        if (!!this.fileList && this.fileList.length > 0) {
            this.loadingMessage = this._$translate.instant('Importing CSV file');
            this.isLoading = true;
            this._accountService
                .upload(this.fileList[0])
                .then(response => {
                    if (response) {
                        this.importResult = {
                            result: response.result,
                            createdCount: response.created.length,
                            updatedCount: response.updated.length,
                            failedCount: response.notUpdated.length
                        };
                        // Translate messages
                        this.setImportResultMessage();
                        // Some or all users haven't been uploaded
                        this.logresults();
                        this.refresh();
                    }
                })
                .catch(reason => {
                    this._loggerService.logError('File cannot be uploaded');
                    this._loggerService.logError(reason.data.message || reason.data.Message);
                })
                .finally(() => {
                    this.fileList = undefined;
                    this.isLoading = false;
                });
        }
    }

    private logresults() {
        if (this.importResult.failedCount > 0) {
            if (this.importResult.createdCount === 0 && this.importResult.updatedCount === 0) {
                this._loggerService.logError(this._$translate.instant('File uploaded successfully but all users have errors'));
            } else {
                this._loggerService.logWarning(this._$translate.instant('File uploaded successfully but some user have errors'));
            }
            // All users added/updated successfully
        } else {
            this._loggerService.logSuccess(this._$translate.instant('File uploaded successfully and all user imported successfully'));
        }
    }

    private setImportResultMessage() {
        if (this.importResult.result.message) {
            let find = 'Forbidden or unknown header';
            let regEx = new RegExp(find, 'g');
            this.importResult.result.message = this.importResult.result.message.replace(regEx, this._$translate.instant('Forbidden or unknown header'));
            find = 'User name cannot be empty';
            regEx = new RegExp(find, 'g');
            this.importResult.result.message = this.importResult.result.message.replace(regEx, this._$translate.instant('User name cannot be empty'));
        }
    }

    private reset(): void {
        this.importResult = undefined;
        this.fileList = undefined;
    }
}

export const wtImportUserCsvModal: ComponentDefinition = {
    componentId: 'wtImportUserCsvModal',
    controller: ImportUserCsvModalController,
    template: require('./importUserCsvModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        modalId: '<',
        refresh: '&'
    }
};